import { createActionGroup, props } from '@ngrx/store';

export const TitleActions = createActionGroup({
  source: 'Title',
  events: {
    'Update Title': props<{ title: string }>(),
  },
});
